/**
 * Returns true only for app-internal paths safe to pass to
 * `Router.navigateByUrl`. Rejects absolute URLs (`https://…`),
 * protocol-relative URLs (`//evil.com`) and anything not starting with `/`.
 */
export function isSafeInternalUrl(url: string | null | undefined): url is string {
  return !!url && url.startsWith('/') && !url.startsWith('//') && !url.includes('\\');
}
